<template>
  <!-- STATUS-->
  <v-container
    fluid
    class="mt-12 mb-12"
    :style="'overflow-y: scroll; max-height: 100%;'"
  >
    <v-card dark>
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="d-flex justify-center text-center">
          <span class="text-h5" :style="'color: cyan;'">Status zamówienia</span>
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <v-text-field
            :style="'max-width: 400px;'"
            v-model="orderNumber"
            label="Numer zamówienia"
            counter="7"
            filled
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          class="d-flex justify-center"
          v-if="statusText.length > 0"
        >
          <v-alert
            border="top"
            colored-border
            type="info"
            elevation="2"
            :style="'max-width: 400px;'"
          >
            {{ statusText }}
          </v-alert>
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <v-btn @click="getOrderStatus" :loading="statusLoading"> Sprawdź status </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "OrderStatusView",
  data: () => ({
    orderNumber: "",
    statusLoading: false,
    statusText: "",
    statuses:{
      "status_unknown":"Nieznany status zamówienia!",
      "not_found":"Nie znaleziono zamówienia!",
      "awaiting_payment":"Oczekuje na płatność!",
      "payment_expired":"Płatność wygasła!",
      "payment_received":"Płatność przyjęta i oczekuje na potwierdzenie!",
      "payment_confirmed":"Płatność potwierdzona! Twoje zamówienie niebawem będzie przez nas przetwarzane!",
      "order_processing":"Przetwarzamy twoje zamówienie",
      "order_processed":"Twoje zamówienie zostało przetworzone i wysłane!"
    }
  }),
  components: {},
  methods: {
    getOrderStatus: function () {
      if (this.orderNumber.length != 7) {
        this.$toast.open({
          message: `<span class="font-weight-bold">Podaj poprawny numer zamówienia (7 znaków)!</span>`,
          type: "error",
          duration: 3000,
          position: "bottom",
        });
        return;
      }
      this.statusLoading = true;
      this.$axios
        .post("/api/order/status", {
          orderNumber: this.orderNumber,
        })
        .then(async (response) => {
          if (response.data.success) {
            this.statusLoading = false;
            this.statusText = this.statuses[response.data.status]?this.statuses[response.data.status]:'Nieznany status zamówienia!';
          } else {
            this.$toast.open({
              message: `<span class="font-weight-bold">Błąd podczas pobierania statusu zamówienia!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });
            this.statusLoading = false;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas pobierania statusu zamówienia!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.statusLoading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style>
.bg-transparent {
  background-color: transparent !important;
}
</style>
